import { createMasterplanSelectJourney } from "api";
import { getCookie, setCookie } from "utils/StorageVariables";
import { ActionTypes } from "./types";

import Notify from "utils/notify";

export const CreateMasterplanSelectJourney =
  (Data, name, id, onSuccess) => async (dispatch) => {
    try {
      const userDetails = JSON.parse(getCookie("userData"));
      const selectedClient = getCookie("selectedClient");
      let query = ``;
      if (userDetails?.type === "Coach" && selectedClient) {
        query = `?coaching_user=${selectedClient}`;
      }
      dispatch({ type: ActionTypes.LOADING });
      const { data, status } = await createMasterplanSelectJourney(Data, query);
      dispatch({
        type: ActionTypes.SUCCESS,
        payload: data,
      });
      if (status === 201) {
        setCookie("MasterPlanId", data?.id);
        setCookie("JourneyId", data?.journey?.id);

        onSuccess(id, name);
      }
    } catch (error) {
      Notify.error(
        Array.isArray(error?.response?.data) && error?.response?.data.length > 0
          ? error.response.data[0]
          : "An error occurred while creating the masterplan"
      );

      dispatch({
        type: ActionTypes.ERROR,
        payload: error?.response?.data[0],
      });
    }
  };

export const CreateMasterplanSetError = (decision) => async (dispatch) => {
  dispatch({
    type: ActionTypes.ERROR,
    payload: decision,
  });
};
